import { useEffect, useRef, useState } from "react";
import { Activity, CalendarDays, Map } from "lucide-react";

/**
 * links: [{ kind, value, icon }]
 * Renders each icon as a button. Clicking opens a small modal with the value.
 * Clicking anywhere else or pressing Esc closes it.
 */
export default function ContentLinks({ links = [] }) {
  const [openIdx, setOpenIdx] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    function onDocMouseDown(e) {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) setOpenIdx(null);
    }
    function onEsc(e) {
      if (e.key === "Escape") setOpenIdx(null);
    }
    document.addEventListener("mousedown", onDocMouseDown);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <div className="segment-links" ref={containerRef}>
      {links.map((l, idx) => {
        const isOpen = openIdx === idx;
        return (
          <div className="icon" key={`${l.kind}-${idx}`}>
            <button
              type="button"
              className={`svg link-trigger ${l.kind}-link`}
              aria-haspopup="dialog"
              aria-expanded={isOpen}
              aria-controls={`link-popover-${idx}`}
              onClick={() => setOpenIdx(isOpen ? null : idx)}
              title={l.kind}
            >
              {l.icon === "map" && <Map size="20" alt={l.kind} />}
              {l.icon === "status" && <Activity size="20" alt={l.kind} />}
              {l.icon === "reservation" && (
                <CalendarDays size="20" alt={l.kind} />
              )}

              {/* <img
                src={l.icon}
                width="24"
                height="24"
                className="link-icon"
                alt={l.kind}
              /> */}
            </button>

            {isOpen && (
              <div
                id={`link-popover-${idx}`}
                role="dialog"
                aria-label={`${l.kind} info`}
                className="link-popover"
              >
                <div className="link-popover-content">{renderValue(l)}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function renderValue(l) {
  const v = (l.value || "").trim();

  // URL-like values (web/reservation/status/map)
  if (
    l.kind === "web" ||
    l.kind === "reservation" ||
    l.kind === "status" ||
    l.kind === "map" ||
    /^https?:\/\//i.test(v)
  ) {
    return v ? (
      <a href={v} target="_blank" rel="noopener noreferrer">
        {v}
      </a>
    ) : (
      <span>No {l.kind} provided</span>
    );
  }

  if (l.kind === "email") {
    return v ? <a href={`mailto:${v}`}>{v}</a> : <span>No email provided</span>;
  }

  if (l.kind === "phone") {
    return v ? <a href={`tel:${v}`}>{v}</a> : <span>No phone provided</span>;
  }

  // Plain text (address or anything else)
  return v ? <span>{v}</span> : <span>No {l.kind} provided</span>;
}

// previous
// import React from "react";

// export default function ContentLinks({ links = [] }) {
//   if (!links.length) return <div className="segment-links" />;
//   return (
//     <div className="segment-links">
//       {links.map((l, idx) => (
//         <div key={idx} className="icon">
//           <div className="svg round">
//             <div className="tooltip">
//               <img
//                 src={l.icon}
//                 width="24"
//                 height="24"
//                 className="link-icon"
//                 alt={l.kind}
//                 title={l.kind}
//               />
//               <span className="tooltiptext">{l.value}</span>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }
